import { Box, HStack, Skeleton, Stack } from '@chakra-ui/react';

export const LoginFormSkeleton = () => {
  return (
    <Stack spacing="6" overflowY="auto" data-test="login-form-skeleton">
      <Stack spacing="6">
        <Stack spacing={{ base: '2', md: '3' }} textAlign="center">
          {/* Heading skeleton */}
          <Skeleton height={{ base: '20px', md: '24px' }} width="200px" mx="auto" />

          {/* Sign up link skeleton */}
          <HStack spacing="1" justify="center">
            <Skeleton height="16px" width="140px" />
            <Skeleton height="16px" width="60px" />
          </HStack>
        </Stack>
      </Stack>

      <Box py="4" px={{ base: '4', sm: '10' }} bg="white">
        {/* Google Sign-in button skeleton */}
        <Skeleton height="40px" width="100%" mb="6" />

        <Stack spacing="6">
          <Stack spacing="5">
            {/* Email field skeleton */}
            <Stack spacing="2">
              <Skeleton height="16px" width="40px" />
              <Skeleton height="40px" width="100%" />
            </Stack>

            {/* Password field skeleton */}
            <Stack spacing="2">
              <Skeleton height="16px" width="70px" />
              <Skeleton height="40px" width="100%" />
            </Stack>
          </Stack>

          {/* Forgot password link skeleton */}
          <HStack justify="space-between">
            <Skeleton height="16px" width="120px" />
          </HStack>

          {/* Login button skeleton */}
          <Stack spacing="6" pb={8}>
            <Skeleton height="40px" width="100%" />
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
};

export default LoginFormSkeleton;
